<span *ngIf="this.appData.selectedComapnyId !== undefined">
<b>{{eduSys.name}} &nbsp; &nbsp;{{eduSys.registrationNo}}</b>
<button mat-button color="primary" (click)="createIndividualMember()">Create
		Members/Staff</button>
</span>


<div class="col-md-12">
	<table class="table table-responsive table-hover">
		<tr class="text-color-top2">
			<th colspan="4" ><pagination-controls (pageChange)="pageChanged($event)"></pagination-controls> </th>
			<th colspan="2" *ngIf="config.totalItems >= 0" class="divider-vertical-header-full-height td-align-right">
				Total Record: {{config.totalItems}}
			</th>
			<th colspan="2" class="divider-vertical-header-full-height td-align-right">
				<mat-select [(value)]="itemPerPageSelection" class="itemsPerPage-option-width"
					(selectionChange)="changeItemSelectionData(itemPerPageSelection, $event)">
					<mat-option value="1">1</mat-option>
					<mat-option value="5">5</mat-option>
					<mat-option value="10">10</mat-option>
					<mat-option value="25">25</mat-option>
					<mat-option value="50">50</mat-option>
				</mat-select>
				Record Page Size
			</th>
		</tr>
		<tr>
			<th>SN</th>
			<th>User Id</th>
			<th class="divider-vertical-header-full-height">Name</th>
			<th class="divider-vertical-header-full-height">Last Name</th>
			<th class="divider-vertical-header-full-height">Individual Type</th>
			<th class="divider-vertical-header-full-height">Status</th>
			<th class="divider-vertical-header-full-height">Edit Record</th>
			<th class="divider-vertical-header-full-height">View Test Result</th>
			<th class="divider-vertical-header-full-height">Edit Test Data</th>
			<th class="divider-vertical-header-full-height">Delete</th>
			<th *ngIf="this.appData.userId=='Admin'" class="divider-vertical-header-full-height" >Hard Delete</th>
		</tr>
		<tr *ngFor="let item of records | paginate: config; let i = index ">
			<td>{{i+1}}</td>
			<td class="divider-vertical-data-full-height">{{item.loginUserId}}</td>
			<td class="divider-vertical-data-full-height">{{item.firstName}} {{item.middleName}}</td>
			<td class="divider-vertical-data-full-height">{{item.lastName}}</td>
			<td class="divider-vertical-data-full-height">{{item.individualType}}</td>
			<td class="divider-vertical-data-full-height">
				<span *ngIf="this.appData.userId!='Admin'">{{item.status}}</span>
				  <mat-select *ngIf="this.appData.userId=='Admin'" class="status-option-width"
				   [disabled]="item.loginUserId==this.appData.userId || item.status=='DELETED'" 
				   [(value)]="item.status" (selectionChange)="changeStatusConfirmation(i, item, $event)">
				    <mat-option value="ACTIVE">Active</mat-option>
				    <mat-option value="BLOCKED">Blocked</mat-option>
				    <mat-option value="DELETED">Deleted</mat-option>
				    <mat-option value="EXPIRED">Expired</mat-option>
				    <mat-option value="INACTIVE">InActive</mat-option>
				  </mat-select>
			</td>
			<td class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.UPDATE_INDIVIDUAL"><a (click)="updateIndividual(item.id,'record')">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a></span> &nbsp;
			</td>
			
			<td class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.VIEW_OTHERS_TEST || this.appData.availablePrivileges.value.VIEW_OTHERS_TEST_WITH_RESULT">
				<a [routerLink]="['/dashboard-test-series',{'p':'x', 'u':item.loginUserId}]">
				<button mat-button>
					<mat-icon>remove_red_eye</mat-icon>
				</button>
				</a>
				</span>&nbsp;
			</td>
			<td class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.CREATE_TEST_SERIES"><a (click)="updateIndividual(item.loginUserId, 'series')">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a></span> &nbsp;
			</td>
			<td class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.UPDATE_INDIVIDUAL">
				<button mat-button (click)="deleteIndividual(item.id)">
					<mat-icon>delete_forever</mat-icon> 
				</button>
				<!--<a [routerLink]="['/individual-delete',{'id':item.id}]">
				<button >
					<mat-icon>delete_forever</mat-icon>
				</button>
				</a>-->
				</span>&nbsp;
			</td>
			<td *ngIf="this.appData.userId=='Admin'" class="divider-vertical-data-full-height"><span *ngIf="this.appData.availablePrivileges.value.UPDATE_INDIVIDUAL">
				<button mat-button (click)="hardDeleteIndividual(item.id)">
					<mat-icon>delete_forever</mat-icon> 
				</button>
				</span>&nbsp;
			</td>
			
		</tr>
	</table>
</div>